import { useState } from "react";
import { Button, Input, Typography } from "antd";
import { useTranslation } from "../../i18n";

const { Title, Paragraph } = Typography;

function VideoReviewNameGate({ videoName, defaultName = "", onSubmit, onBack }) {
    const { t } = useTranslation();
    const [name, setName] = useState(defaultName);
    const [error, setError] = useState("");

    const handleSubmit = () => {
        const trimmed = name.trim();
        if (!trimmed) {
            setError(t("videoReview.name.required"));
            return;
        }
        setError("");
        onSubmit(trimmed);
    };

    return (
        <div className="delivery-card selection-name-gate">
            <Title level={3} className="delivery-consent__title">
                {t("videoReview.name.title")}
            </Title>
            {videoName && (
                <Paragraph className="selection-name-gate__album">{videoName}</Paragraph>
            )}
            <Paragraph className="delivery-consent__text">{t("videoReview.name.subtitle")}</Paragraph>

            <Input
                size="large"
                value={name}
                maxLength={80}
                placeholder={t("videoReview.name.placeholder")}
                onChange={(e) => setName(e.target.value)}
                onPressEnter={handleSubmit}
                status={error ? "error" : undefined}
            />
            {error && (
                <Paragraph type="danger" style={{ marginTop: "0.5rem", marginBottom: 0 }}>
                    {error}
                </Paragraph>
            )}

            <div className="delivery-consent__actions">
                <Button type="primary" size="large" block onClick={handleSubmit}>
                    {t("videoReview.name.start")}
                </Button>
                {onBack && (
                    <Button type="default" size="large" block onClick={onBack}>
                        {t("videoReview.name.back")}
                    </Button>
                )}
            </div>
        </div>
    );
}

export default VideoReviewNameGate;
